import { Container, Form, FormField, Header, Link, SpaceBetween } from "@cloudscape-design/components";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import { mdiCertificateOutline, mdiInformation } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { formatTowType } from "../../pages/commons/functions";
import { btnDanger, ItemBooking } from "../../resources/types";
import HorizontalRule from "../HorizontalRule";
import BadgeCustom from "./BadgeCustom";
import RangeSlider from "./RangleSlider";
import Spacer from "./Spacer";
import UserAvatar from "./UserAvatar";

export interface BookingProps {
    booking: ItemBooking;
    idUser?: number;
    range?: boolean;
    date?: string;
    onDelete?: (booking: ItemBooking) => void;
    onDismiss?: () => void;
}

export const Booking: React.FC<BookingProps> = ({
    booking,
    idUser = 0,
    range = true,
    date,
    onDelete,
    onDismiss,
}) => {


    const towType = {
        MOUNTAIN: <BadgeCustom color="lime">C</BadgeCustom>,
        SANRAMON: <BadgeCustom color="violet">SR</BadgeCustom>,
        LOCAL: <BadgeCustom color="brown">LC</BadgeCustom>,
        NONE: <BadgeCustom color="grey">AD</BadgeCustom>,
        BALLAST: <BadgeCustom color="violet">LA</BadgeCustom>
    }
    return (
        <Modal visible={!!booking} size="medium" header={`Reserva #${booking.idBooking}`}
            onDismiss={() => {
                if (onDismiss) {
                    onDismiss();
                }
            }}

        >

            <Form
                secondaryActions={<Button variant="link" onClick={() => {
                    if (onDismiss) {
                        onDismiss();
                    }
                }}>Cerrar</Button>}
                actions={
                    idUser === booking.idUser && onDelete && (
                        <Button style={{ root: btnDanger }} onClick={() => {
                            if (onDelete) {
                                onDelete(booking);
                            }
                        }}>Eliminar</Button>
                    )}>

                <Header key={`HDR${booking.idBooking}`} variant="h3"
                // Corrected actions prop:

                >
                    <SpaceBetween direction="vertical" size="xs" key={`CT2${booking.idBooking}`}>

                        <Link variant="awsui-value-large" key={`REG${booking.idBooking}`}>{booking.equipment === '' ? booking.registration : booking.equipment}</Link>

                    </SpaceBetween>
                </Header>
                <SpaceBetween direction="vertical" size="xs" key={`SB${booking.idBooking}`}>
                    {/* 💡 ADDED KEY HERE */}
                    <Form key={`FORM${booking.idBooking}`}
                    >
                        <SpaceBetween direction="horizontal" size="l" key={`INST${booking.idBooking}`}>
                            <FormField label="Usuario">
                                <SpaceBetween direction="horizontal" size="xxxs">
                                    <UserAvatar idUser={booking.idUser} width={30} />
                                    {booking.displayName}
                                </SpaceBetween>
                            </FormField>
                            {
                                booking.instructor && booking.instructor !== '' ? (

                                    <FormField label="Instructor">
                                        <SpaceBetween direction="horizontal" size="xxxs">
                                            <div style={{ height: 30, width: 1 }}>
                                            </div>
                                            {booking.instructor}
                                        </SpaceBetween>
                                    </FormField>
                                ) : null}
                        </SpaceBetween>
                        <Spacer height={10} />

                        <SpaceBetween direction="vertical" size="xs">
                            <SpaceBetween direction="horizontal" size="xs">


                                <FormField label="Tipo" constraintText={booking.idRequest > 0 ? `Solicitud #${booking.idRequest}` : ""}>
                                    <>
                                        <BadgeCustom key={`BT${booking.idBooking}`} color={booking.bookingTypeBadge}>{booking.bookingType.substring(0, 1)}</BadgeCustom>
                                        {booking?.bookingType}</>
                                </FormField>
                                {booking.equipmentType === "GLIDER" && (
                                    <div style={{ marginLeft: 5, marginRight: 5, width: 1, backgroundColor: "#eee", top: 0, bottom: 0, height: "100%" }}></div>
                                )}
                                {booking.equipmentType === "GLIDER" && (


                                    <FormField label="Remolque">
                                        <><span key={`DV${booking.idBooking}`}>{towType[booking.towType as keyof typeof towType]}</span> {formatTowType(booking?.towType)}</>
                                    </FormField>
                                )}


                                <div style={{ marginLeft: 5, marginRight: 5, width: 1, backgroundColor: "#eee", top: 0, bottom: 0, height: "100%" }}></div>
                                <FormField label="Emisión" constraintText={booking.dateSubmited}>
                                    <Icon path={mdiCertificateOutline} size={1} />{` ${booking.timeSubmited}`}
                                </FormField>
                                {booking.pax > 0 && booking.maxPAX > 0 && (

                                    <SpaceBetween direction="horizontal" size="xs">
                                        <div style={{ marginLeft: 5, marginRight: 5, width: 1, backgroundColor: "#eee", top: 0, bottom: 0, height: "100%" }}></div>
                                        <FormField label="Asisten">
                                            {booking.pax} PAX
                                        </FormField>
                                    </SpaceBetween>
                                )}
                            </SpaceBetween>

                            {booking?.obsBooking !== "" && (
                                <Container header={<Header variant="h3">Observaciones</Header>}>
                                    {booking?.obsBooking !== "" ? <><Icon path={mdiInformation} size={0.75} /> {booking?.obsBooking}</> : "-----"}
                                </Container>
                            )}

                        </SpaceBetween>
                        <HorizontalRule height={1} />
                        {/* Content inside Form uses keys correctly */}
                        {!range && (
                            <div key={`R1${booking.idBooking}`}>
                                {booking.dateStart !== booking.dateEnd
                                    ? `${booking.dateStart} ${booking.timeStart} - ${booking.dateEnd} ${booking.timeEnd}`
                                    : `${booking.dateStart} ${booking.timeStart} - ${booking.timeEnd}`}
                            </div>
                        )}

                        {range && (
                            <div key={`RS${booking.idBooking}`}>
                                <RangeSlider
                                    evtEndTH={booking.thresholdAfter}
                                    evtStartTH={booking.thresholdBefore}
                                    marginVertical={0}
                                    date={date ? date : booking.dateStart}
                                    evtStart={`${booking.dateStart} ${booking.timeStart}`}
                                    evtEnd={`${booking.dateEnd} ${booking.timeEnd}`}
                                    start={booking.minBookHour}
                                    end={booking.maxBookHour}
                                />
                            </div>
                        )}
                    </Form>
                </SpaceBetween>


            </Form >
        </Modal >
    );
};

export default Booking;
